import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PaymentForm } from '../components/PaymentForm';
import { SettingsIcon } from 'lucide-react';
export function PaymentRequests() {
  const navigate = useNavigate();
  const navigateToSettings = () => {
    window.location.href = '/settings';
  };
  return <div data-id="element-7615">
      {/* Header with settings button */}
      <div className="mb-6 flex justify-between items-center" data-id="element-7616">
        <h2 className="text-lg font-medium text-gray-800" data-id="element-7617">
          Create Payment Request
        </h2>
        <div data-id="element-7618">
          <button className="flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors" onClick={navigateToSettings} data-id="element-7619">
            <SettingsIcon size={16} className="mr-2" data-id="element-7620" />
            Payment Settings
          </button>
        </div>
      </div>
      <PaymentForm data-id="element-7621" />
    </div>;
}